import {DeletedFollowableTopic} from '../resources/DeletedFollowableTopic';
import {DomainEvent} from './DomainEvent';

/**
 * This event is raised when a followable entity has either been manually deleted or expired. A common example
 * is a match, which expires some days after kickoff.
 */
export class FollowableTopicDeleted extends DomainEvent<DeletedFollowableTopic> {}
